export default __webpack_public_path__ + "static/media/WGP-white.c53e1876.png";